/* Consent-gated Shopify wrapper. Pulse only measures email journeys by default;
   broader site analytics remains with the existing first-party pixel (e.g. Layer Insights).
   Never infer consent from navigation, a CTA click or a UTM value. */
(function(){
 'use strict';var uninstall=function(){};
 var uuid=function(v){return typeof v==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);};
 // No storage access until Shopify confirms affirmative analytics AND marketing consent.
 function emailJourney(options){
  if(options&&options.emailOnly===false)return true;
  var params;
  try{params=new URL(window.location.href).searchParams;}catch(_err){return false;}
  var medium=(params.get('utm_medium')||'').trim().toLowerCase();
  // Klaviyo appends _kx to email AND SMS links. Neither _kx nor utm_source
  // alone proves an email journey; explicit SMS evidence takes precedence.
  if(['sms','text','whatsapp','push'].includes(medium))return false;
  if(options&&uuid(options.message))return true;
  if(uuid(params.get('pulse_message')))return true;
  if(medium==='email')return true;
  // A new unqualified Klaviyo/platform referral is not proof that this
  // is the same previously verified email journey; do not reuse old proof.
  var source=(params.get('utm_source')||'').trim().toLowerCase();
  if(params.has('_kx')||['klaviyo','mailchimp','omnisend'].includes(source))return false;
  try{
   if(!options||!options.token)return false;
   var key='pulse_attribution_'+options.token.split('_').slice(0,2).join('_');
   var item=JSON.parse(window.sessionStorage.getItem(key)||'null');
   return !!(item&&item.expires>Date.now()&&(uuid(item.message)||item.emailSourceProof==='utm_email'));
  }catch(_err){return false;}
 }
 window.PulseShopify={install:function(options){
  uninstall();var running=false,alive=true;
  function update(){
   if(!alive)return;
   var privacy=window.Shopify&&window.Shopify.customerPrivacy,consent=null;
   try{consent=privacy&&privacy.currentVisitorConsent();}catch(_error){}
   var allowed=consent&&consent.analytics==='yes'&&consent.marketing==='yes';
   if(allowed&&!running&&window.PulseTracker&&emailJourney(options))running=window.PulseTracker.start(Object.assign({},options,{consent:true}));
   if(!allowed&&window.PulseTracker){window.PulseTracker.stop();running=false;}
  }
  document.addEventListener('visitorConsentCollected',update);
  uninstall=function(){alive=false;running=false;document.removeEventListener('visitorConsentCollected',update);if(window.PulseTracker)window.PulseTracker.stop();};
  var shop=window.Shopify;
  if(shop&&shop.customerPrivacy)update();
  else if(shop&&typeof shop.loadFeatures==='function')shop.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)update();});
  return uninstall;
 }};
})();
